var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),(!_vm.fullyInit)?_c('Loading',{attrs:{"error-message":_vm.errorMessage}}):_vm._e(),(_vm.fullyInit)?_c('QuestionComponent',{attrs:{"categories":_vm.categories,"category-names":_vm.categoryNames,"user-answers":_vm.userAnswers,"paths":_vm.paths}}):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }